import React from 'react';
import TagsContainer from '../Containers/TagsContainer';

const Tags = (props) => {
	return (
		<TagsContainer />
	);
}
export default Tags;